module.exports = __webpack_public_path__ + "img/uid-popup-hen.13e6bd72.png";